module.exports = __webpack_public_path__ + "static/media/resume.cea0627f.svg";